(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Bottle scene (snippets/consumer-bottle-scene). This file only sets three class
  // names on .val-bottles and runs the timer that changes the names; every number and
  // everything you see is in consumer-bottle-scene.css.
  // How to change or move the scene: docs/engineering/bottle-scene.md
  const init = function (panel) {
    if (panel.dataset.bottlesReady === 'true') return;
    const rolls = Array.prototype.map.call(panel.querySelectorAll('[data-bottles-roll]'), function (roll) {
      return roll.querySelectorAll('[data-bottles-word]');
    });
    const count = rolls.length ? rolls[0].length : 0;
    if (count < 2) return;

    panel.dataset.bottlesReady = 'true';

    const seconds = parseFloat(panel.dataset.bottlesInterval) || 2.4;
    let current = count - 1; // Liquid renders the last name as the active one.
    let timer = null;

    // Every bottle carries the same list, so one index drives them all. CSS staggers
    // the bottles with transition-delay.
    const show = function (next) {
      rolls.forEach(function (words) {
        const incoming = words[next];
        const outgoing = words[current];
        if (!incoming || !outgoing) return;

        // Put the incoming name back to its waiting place without animating it there,
        // otherwise a name that already left upward would drift back down as it returns.
        incoming.style.transition = 'none';
        incoming.classList.remove('is-past');
        void incoming.offsetWidth;
        incoming.style.transition = '';

        outgoing.classList.remove('is-active');
        outgoing.classList.add('is-past');
        incoming.classList.add('is-active');
      });
      current = next;
    };

    // The arrival plays once: the scene waits dim (.is-waiting) until it first comes on
    // screen, then .is-lit wipes the veil away behind one band of light. .is-live runs
    // the moving light for as long as the scene stays on screen.
    panel.classList.add('is-waiting');
    let lit = false;

    const start = function () {
      if (!lit) {
        lit = true;
        panel.classList.remove('is-waiting');
        panel.classList.add('is-lit');
      }
      panel.classList.add('is-live');
      if (timer) return;
      timer = window.setInterval(function () {
        show((current + 1) % count);
      }, seconds * 1000);
    };

    const stop = function () {
      panel.classList.remove('is-live');
      window.clearInterval(timer);
      timer = null;
    };

    // A background tab keeps firing timers but freezes transitions, which would leave
    // the bottles showing different names when the visitor comes back. So the timer
    // needs both: the panel on screen and the tab in front.
    let onScreen = false;
    const sync = function () {
      if (onScreen && !document.hidden) start();
      else stop();
    };

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          onScreen = entry.isIntersecting;
        });
        sync();
      },
      // A fifth of the scene in view is enough to begin. Waiting for more leaves the
      // dim, waiting picture on screen with nothing happening.
      { threshold: 0.2 }
    ).observe(panel);

    document.addEventListener('visibilitychange', sync);
  };

  document.querySelectorAll('[data-bottles]').forEach(init);

  // Theme editor re-renders the section as a fresh node.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-bottles]').forEach(init);
    });
  }
})();
